import { ref } from "vue";
import useApi from "../../../composables/useApi";
import { DepartureRequest } from "../models/QuickformApi";

export type Response = {
    bookitErrorCode: number;
    error: boolean;
    internal: boolean;
    message: string;
    result: boolean | string;
    token: string;
};

const { post } = useApi();
const useCreateRequest = () => {
    const isLoading = ref(false);
    const create = (req: DepartureRequest[]) => {
        isLoading.value = true;
        return post<Response>("/booking/create", {
            departureRequests: req,
            productCode: "",
        })
            .then(({ data }) => data)
            .finally(() => {
                isLoading.value = false;
            });
    };

    return {
        create,
        isLoading
    };
};

export default useCreateRequest;
